<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="conditions.ownerPhone" placeholder="请输入业主手机号" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryData">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>房屋绑定管理</span>
      </div>
      <div class="">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="communityName" label="小区名称" align="center" />
          <el-table-column prop="roomName" label="房屋名称" align="center" />
          <el-table-column prop="ownerName" label="业主姓名" align="center" />
          <el-table-column prop="ownerPhone" label="业主手机号" align="center" />
          <el-table-column prop="createTime" label="绑定时间" align="center" />
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="_openDeleteModal(scope.row)">删除绑定</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next, jumper" style="margin-top: 20px;" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { listShopQrCodeHouses, deleteShopQrCodeHouse } from '@/api/phone/shopQrCodeApi'

export default {
  name: 'ShopQrCodeHouse',
  data() {
    return {
      conditions: {
        ownerPhone: ''
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._queryData()
  },
  methods: {
    async _queryData() {
      try {
        const res = await listShopQrCodeHouses({
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize,
          ownerPhoneLike: this.conditions.ownerPhone || ''
        })
        this.total = res.total
        this.list = res.data
      } catch (error) {
        console.error('查询失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._queryData()
    },
    _openDeleteModal(row) {
      this.$confirm('确认删除该房屋绑定？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteShopQrCodeHouse({ bindId: row.bindId })
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.currentPage = 1
            this._queryData()
          }
        } catch (error) {
          console.error('删除失败:', error)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>
